<script>
  import { createEventDispatcher, onMount, onDestroy } from 'svelte';
  import request from 'superagent';
  import Select from 'svelte-select';
  //import { categories as default_categories_store } from './stores.js';
  import { schemas as default_schemas_store } from './stores.js';
  
  const defaultLink = { id: null, language: "cs", title: "", uri: "" };
  const defaultCategory = {name: "", id: null, is_meta: false };
  const defaultSubject = { links: [], categories: [], content: {}, name: "" };
  const defaultSchemaField = { name: "", type: "text", label: "", dirty: false, original_name: "" };
  const dispatch = createEventDispatcher();
  
  export let id = null;
  export let subject = Object.assign({}, defaultSubject);
  export let subject_form_id = null;
  export let categories = [];
  
  let schema = null;
  let schema_dirty = false;
  let meta_category_tree = {};
  
  $: subject = Object.assign({}, defaultSubject, subject || {}), !('exists' in subject); // && getSubject();
  $: schema = bestPossibleSchema();
  $: if (schema) { schema_dirty = schema.some( (e) => e.dirty ) };
  
  
  const INFO_CONTENT       = 0;
  const LINKS_CONTENT      = 1;
  const VIDEOS_CONTENT     = 2;
  const CATEGORIES_CONTENT = 3;
  
  
  let visible_content = INFO_CONTENT;
  let response = null;
  
  
  /*subject_store.subscribe(value => {
    if (value  != 'undefined' || !value)
      subject = value;
  });*/
  
  function makeTreeMap(list) {
    var map = {}, node, roots = {}, i;
    for (i = 0; i < list.length; i++) {
        map[list[i].id] = i; // initialize the map
        list[i].children = {}; // initialize the children
    }
    for (i = 0; i < list.length; i++) {
        node = list[i];
        if (node.parent_id && node.parent_id !== null) {
            // if you have dangling branches check that map[node.parentId] exists
            list[map[node.parent_id]].children[node.id] = node;
        } else {
          roots[node.id] = node;
        }
    }
    return roots;
  }
  
  
  
  function bestPossibleSchema() {
    if (schema)
      return schema;
    if (subject) {
      if (subject.content_schema_id) {
      // download schema
      } else if (subject.content.schema) {
        schema = [];
        Object.entries(subject.content.values).forEach((e) => {
          const [key, value] = e;
          schema = [...schema, Object.assign({}, defaultSchemaField, { name: key, original_name: key })]
        })
      }
    }
    return schema;
  }
  
  function getSubject() {
    if (subject['exists'])
      return;
    subject.id = id;
    fetch(`/ix/x/${window.atob(subject.id)}.json`)
      .then(r => r.json())
      .then(data => {
        subject = Object.assign(subject, defaultSubject, data);
        subject.exists = !!subject.id;
        window.scrollTo(0, 0);
        console.log(subject.categories);
        dispatch('subject', Object.assign({}, defaultSubject, subject));
      })
      .catch(resp => {
        console.log("error when getting subject")
      });
  }
  
  function onFieldChange(i) {
    schema[i].dirty = true;
  }
  
  function commit() {
  }
  function cancel() {
    dispatch('subject', null)
  }
  function commit_schema() {
  }
  function create_schema() {
  }
  
  onMount(() => {
    meta_category_tree = makeTreeMap(subject.categories.filter((c) => c.is_meta ));
    console.log(meta_category_tree)
  })
</script>
<div class='d-flex justify-content-between'>
<div class='d-item'>
<button class='btn btn-outline-secondary border-0' on:click='{cancel}'>
<i class='fa fa-times'></i>
</button>
<button class:btn-outline-primary='{!subject.name}' class='btn border-0 btn-primary' disabled='{!subject.name || schema_dirty}' on:click|preventDefault='{() => commit()}' type='submit'>
<i class='fa fa-save'></i>
<div class='d-none d-md-inline'>
Uložit
</div>
</button>
</div>
</div>
<div class='bg-white shadow-sm'>
<form action='/form/{subject_form_id}'>
<div class='row'>
<fieldset class='form-group col-12'>
<label class='form-text text-muted' for='subject-name'>Pojmenování</label>
<input bind:value='{subject.name}' class='form-control ui' id='subject-name' placeholder='Pojmenování' type='text'>
</fieldset>
{#if response}
<div class:alert-success='{response.success}' class:alert-warning='{!response.success}' class='alert'>
{response.message}
</div>
{/if}
<div class='col-12 my-2'>
<nav>
<ul class='nav nav-tabs'>
<li class='nav-item flex-sm-fill' on:click='{()=>visible_content=INFO_CONTENT}' on:keypress='{()=>visible_content=INFO_CONTENT}'>
<div class:active='{visible_content == INFO_CONTENT}' class='nav-link flex-row d-flex'>
<div class='btn btn-outline-link border-0'>
informace
</div>
</div>
</li>
<li class='nav-item flex-sm-fill' on:click='{()=>visible_content=CATEGORIES_CONTENT}' on:keypress='{()=>visible_content=CATEGORIES_CONTENT}'>
<div class:active='{visible_content == CATEGORIES_CONTENT}' class='nav-link flex-row d-flex'>
<div class='btn btn-outline-link border-0'>
kategorie
</div>
</div>
</li>
</ul>
</nav>
</div>
</div>
<div class='row'>
{#if visible_content == INFO_CONTENT}
{#if subject && subject.content && subject.content.schema}
<fieldset class='form-group col-12'>
<label class='form-text text-muted' for='subject-content-schema'>Schéma políček</label>
<input bind:value='{subject.content.schema}' class='form-control ui' id='subject-content-schema' placeholder='' type='text'>
</fieldset>
<fieldset class='form-group col-12'>
<label class='form-text text-muted' for='subject-content-schema'>Schéma políček</label>
<Select bind:value='{subject.content_schema_id}' items='{$default_schemas_store}'></Select>
</fieldset>
{:else}
{/if}
{#if schema}
{#if schema_dirty}
<div class='col-12 alert alert-danger'>
<h6>Něco se změnilo.</h6>
<table>
{#each schema as field, i}
{#if field.dirty }
<tr>
<td>{field.original_name}</td>
<td class='text-center align-middle'>&rarr;</td>
<td>{field.name}</td>
</tr>
{/if}
{/each}
</table>
<div class='btn-group w-100 mt-2'>
<button class='btn btn-outline-primary bg-light text dark' on:click='{create_schema}'>
Duplikovat
</button>
<button class='btn btn-outline-danger bg-light text-danger' on:click='{commit_schema}'>
Přepsat
</button>
</div>
</div>
{/if}
{#each schema as field, i}
{#if subject && subject.content && subject.content.values}
<fieldset class='form-group col-12'>
<div class='d-flex'>
<label class:border-danger='{field['dirty']}' class='form-text text-muted flex-fill' style='border-bottom: 1px dashed'>
<input bind:value='{field.name}' class='border-0 text-muted' on:input='{() => onFieldChange(i)}' type='text'>
</label>
<button class='border-0 badge badge-light'>
<i class='fa fa-trash text-danger'></i>
</button>
<button class='border-0 badge badge-light'>
<i class='fa fa-sort text-info'></i>
</button>
</div>
<input bind:value='{subject.content.values[field.name]}' class='form-control ui' placeholder='{subject.content.values[field.original_name]}' type='text'>
</fieldset>
{/if}
{/each}
{/if}
{:else if visible_content == CATEGORIES_CONTENT}
<div class='col-12'>
<h6>zařazení</h6>
<div class='list-group'>
{#each subject.categories as category, i}
{#if category['is_meta']}
<div class='list-group-item text-dark'>
{#each Object.entries(category.name) as [locale, name]}
{name}
{/each}
</div>
{/if}
{/each}
</div>
<h6>seskupení</h6>
<div class='list-group'>
{#each subject.categories as category, i}
{#if !category['is_meta']}
<div class='list-group-item text-dark'>
{#each Object.entries(category.name) as [locale, name]}
{name}
{/each}
</div>
{/if}
{/each}
</div>
</div>
{:else if visible_content == LINKS_CONTENT}
{:else if visible_content == VIDEOS_CONTENT}
{/if}
</div>
</form>
</div>
